/*
 *
 * @desc: 根据时间戳获取倒计时
 * @author: haifn
 * @time: 2020/6/20 14:53
 *
 */

/*
 *
 * @desc: 获取倒计时
 * @param {string} timeStamp //结束时间时间戳（毫秒）
 * @param {function} cb //回调
 * @return {object} result //天、时、分、秒
 * @time: 2020/6/20 14:53
 *
 */
function countdown(timeStamp, cb) {
  if (!timeStamp) return { isEnded: true };
  const nowTimeStamp = Date.parse(new Date()) / 1000;
  const endTimeStamp = timeStamp / 1000;
  const timeDiff = endTimeStamp - nowTimeStamp + 1;
  let d = parseInt(parseInt(timeDiff / 60 / 60) / 24);
  let h = parseInt((timeDiff / 60 / 60) % 24);
  let m = parseInt((timeDiff / 60) % 60);
  let s = parseInt(timeDiff % 60);
  const result = {};
  result.d = d < 10 ? '0' + d : d;
  result.h = h < 10 ? '0' + h : h;
  result.m = m < 10 ? '0' + m : m;
  result.s = s < 10 ? '0' + s : s;
  result.isLastDay = d <= 0;
  result.isEnded = timeDiff <= 0;
  cb && cb(result);
  return result;
}
export { countdown };
